module.exports = __webpack_public_path__ + "img/gift1.923c4928.png";